// Compact feature copy based on Daikin Australia product pages and technology guides.
// Kept deliberately short for a clean icon-led product section.
export const DAIKIN_COMPACT_FEATURES = {
  cora: [
    {
      icon: "leaf",
      title: "R32 Refrigerant",
      desc: "More efficient refrigerant with 66% lower global-warming potential than R410A.",
    },
    {
      icon: "eye",
      title: "Intelligent Eye",
      desc: "Detects room use and can reduce energy use when nobody is there.",
    },
    {
      icon: "wind",
      title: "Coanda Airflow",
      desc: "Sends air along the ceiling for longer throw and more even cooling.",
    },
    {
      icon: "thermometer",
      title: "Precision Control",
      desc: "Set the temperature in precise 0.5°C steps.",
    },
    {
      icon: "filter",
      title: "Air Purification",
      desc: "Enzyme Blue filtration traps fine particles, reduces odours and deactivates bacteria on the filter.",
    },
    {
      icon: "fan",
      title: "Quiet Airflow",
      desc: "Large cross-flow fan moves a strong volume of air with less noise.",
    },
  ],

  "alira-x": [
    {
      icon: "filter",
      title: "Advanced Purification",
      desc: "Three-stage filtration: pre-filter, Enzyme Blue filter and Streamer technology.",
    },
    {
      icon: "zap",
      title: "Streamer Technology",
      desc: "High-speed electrons help break down odours, bacteria and captured indoor pollutants.",
    },
    {
      icon: "wifi",
      title: "Built-In Wi-Fi",
      desc: "Control temperature and operation from your phone without an external Wi-Fi box.",
    },
    {
      icon: "shield",
      title: "Mould-Proof Operation",
      desc: "Dries internal surfaces after cooling or dry mode to help reduce mould and odour build-up.",
    },
    {
      icon: "eye",
      title: "Intelligent Eye",
      desc: "Monitors room occupancy for draught-free comfort and automatic energy saving.",
    },
    {
      icon: "wind",
      title: "Coanda Airflow",
      desc: "Guides air along the ceiling for a longer, softer throw across the room.",
    },
    {
      icon: "droplets",
      title: "Humidity Sensor",
      desc: "Helps Program Dry control humidity while keeping the room comfortable.",
    },
    {
      icon: "arrows",
      title: "Dual Louvres",
      desc: "Redesigned louvres reduce turbulence and improve long-distance airflow.",
    },
  ],

  zena: [
    {
      icon: "minimize",
      title: "Ultra Compact",
      desc: "Only 295 × 798 × 185 mm, so it sits noticeably closer to the wall.",
    },
    {
      icon: "palette",
      title: "White or Black",
      desc: "Available in White Hair Line or Black Wood to suit the room design.",
    },
    {
      icon: "wifi",
      title: "Built-In Wi-Fi",
      desc: "Smartphone control is built into the indoor unit.",
    },
    {
      icon: "wind",
      title: "Coanda Airflow",
      desc: "Streams cooling air along the ceiling for longer throw and even distribution.",
    },
    {
      icon: "arrowdown",
      title: "Vertical Airflow",
      desc: "In heating, warm air is directed down the wall toward the floor.",
    },
    {
      icon: "eye",
      title: "Intelligent Eye",
      desc: "Detects an empty room and automatically enables energy-saving operation.",
    },
    {
      icon: "filter",
      title: "Advanced Filter",
      desc: "Titanium apatite filtration traps fine particles, reduces odours and deactivates bacteria.",
    },
    {
      icon: "fan",
      title: "Saw Edge Fan",
      desc: "Aerofoil blade design moves more air quietly while keeping the casing slim.",
    },
    {
      icon: "grid",
      title: "Grid Eye Sensor",
      desc: "Checks floor temperature in heating and adjusts airflow for more even warmth.",
    },
    {
      icon: "zap",
      title: "Streamer Technology",
      desc: "Plasma discharge helps decompose bacteria and mould captured on the filter.",
    },
  ],
};

export const DAIKIN_STREAMER_FOOTNOTE =
  "Daikin Australia publishes laboratory testing for Streamer technology and Daikin air purifiers against pollutants and viruses. Results depend on the specific product and test conditions; an installed split system is not a guarantee against infection.";
